var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Ai-companion-dialog',{attrs:{"visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event},"closed":_vm.handleCloseDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }